var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-header"},[_vm._m(0),_c('div',{staticClass:"overview-nav"},[_c('router-link',{attrs:{"to":"/total/plugins"}},[_c('div',{class:['item', { select: _vm.$route.path === '/total/plugins' }]},[_vm._v(" 插件列表 "),_c('div',{staticClass:"triangle"})])])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._v("插件"),_c('span',[_vm._v("PLUG-IN UNIT")])])
}]

export { render, staticRenderFns }